import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleModifiersComponent } from './single-modifiers/single-modifiers.component';
import { GroupModifiersComponent } from './group-modifiers/group-modifiers.component';
import { ModifierListComponent } from './modifier-list.component';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { CounterComponent } from '../../shared/components/counter/counter.component';
import { CurrencyComponent } from '../../shared/components/price/currency.component';
import { OutletPricePipe } from '../../shared/pipes/price.pipe';

@NgModule({
  declarations: [
    SingleModifiersComponent,
    GroupModifiersComponent,
    ModifierListComponent,
  ],
  exports: [
    SingleModifiersComponent,
    GroupModifiersComponent,
    ModifierListComponent
  ],
  imports: [
    CommonModule,
    MatRadioModule,
    ReactiveFormsModule,
    CounterComponent,
    CurrencyComponent,
    OutletPricePipe,
  ]
})
export class ModifierListModule { }
